export const setPrintaction = ({ name, target, value }: any) => ({
  type: "SET_PRINT_ACTIONS",
  payload: { name, target, value },
});
export const setPrintclinic = (e: any) => ({
  type: "SET_PRINT_CLINIC",
  payload: e,
});
export const setPrintPatient = (e: any) => ({
  type: "SET_PRINT_PATIENT",
  payload: e,
});
export const setPrintAmount = (e: any) => ({
  type: "SET_PRINT_AMOUNT",
  payload: e,
});
export const setPrintTreatment = (e: any) => ({
  type: "SET_PRINT_TREATMENT",
  payload: e,
});
export const setPrintSubTreatment = (e: any) => ({
  type: "SET_PRINT_SUB_TREATMENT",
  payload: e,
});


// 
export const setPresPrintaction = ({ name, target, value }: any) => ({
  type: "SET_PRESCRIPTIONPRINT_ACTIONS",
  payload: { name, target, value },
});
export const setPresPrintclinic = (e: any) => ({
  type: "SET_PRESCRIPTIONPRINT_CLINIC",
  payload: e,
});
export const setPresPrintPatient = (e: any) => ({
  type: "SET_PRESCRIPTIONPRINT_PATIENT",
  payload: e,
});
export const setPresPrintAmount = (e: any) => ({
  type: "SET_PRESCRIPTIONPRINT_AMOUNT",
  payload: e,
});
export const setPresPrintTreatment = (e: any) => ({
  type: "SET_PRESCRIPTIONPRINT_TREATMENT",
  payload: e,
});
